var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05 0.166504V2.4665H14.95V0.166504H17.25V2.4665H21.85C22.155 2.4665 22.4475 2.58766 22.6632 2.80333C22.8788 3.019 23 3.3115 23 3.6165V22.0165C23 22.3215 22.8788 22.614 22.6632 22.8297C22.4475 23.0453 22.155 23.1665 21.85 23.1665H1.15C0.845001 23.1665 0.552494 23.0453 0.336827 22.8297C0.12116 22.614 0 22.3215 0 22.0165V3.6165C0 3.3115 0.12116 3.019 0.336827 2.80333C0.552494 2.58766 0.845001 2.4665 1.15 2.4665H5.75V0.166504H8.05ZM20.7 10.5165H2.3V20.8665H20.7V10.5165ZM14.9914 11.8229L16.6175 13.449L10.925 19.1415L6.8586 15.0751L8.487 13.449L10.9262 15.8893L14.9925 11.8229H14.9914ZM5.75 4.7665H2.3V8.2165H20.7V4.7665H17.25V5.9165H14.95V4.7665H8.05V5.9165H5.75V4.7665Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLine);
export default __webpack_public_path__ + "static/media/calendar-line.aedbdb61.svg";
export { ForwardRef as ReactComponent };